import { createReducer } from 'reduxsauce';
import { AUTHENTICATION, HITCLUB } from 'actions/Base';

export const INITIAL_STATE = {
  token: null,
  authToken: null,
  userIsLoggedIn: false,
  error: null,
  hitClubUserRole: ""
};

export const onCreateRequest = (state) => ({ ...state, userIsLoggedIn: false });
export const onCreateFailure = (state, { error }) => ({ ...state, userIsLoggedIn: false, ...error });
export const onCreateSuccess = (state, { payload }) => {
  
  return ({
    ...state,
    ...payload,
    userIsLoggedIn: true
  })
  
};

export const onResetRequest = () => INITIAL_STATE;

export const onGetHitClubOwnerSuccess = (state, { payload }) => {
  return ({
    ...state,
    hitClubUserRole: payload.hitClubUserRole
  })
};

// export const onCreateHitClubOwnerSuccess = (state, { payload }) => {
//   return ({
//     ...state,
//     hitClubUserRole: payload.hitClubUserRole
//   })
// };

export const ACTION_HANDLERS = {
  [AUTHENTICATION.CREATE_REQUEST]: onCreateRequest,
  [AUTHENTICATION.CREATE_FAILURE]: onCreateFailure,
  [AUTHENTICATION.CREATE_SUCCESS]: onCreateSuccess,

  [AUTHENTICATION.RESET_REQUEST]: onResetRequest,

  [HITCLUB.GET_CLUB_OWNER_SUCCESS] : onGetHitClubOwnerSuccess,
  // [HITCLUB.CREATE_CLUB_OWNER_SUCCESS] : onCreateHitClubOwnerSuccess
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
